import {
  TextFormField,
  ToggleFormField,
  SelectFormField,
  StaticLabelField,
  CheckboxFormField,
  TextAreaFormField,
  DatepickerFormField,
  MultiselectFormField,
  NumberInputFormField,
  RadioButtonFormField,
  CheckboxListFormField,
  BuildingSearchFormField,
  ProviderSearchFormField,
  RespitePartnersSearchFormField,
  GooglePlacesAutocompleteDynamicFormField,
  BannerField,
  RepeaterTextFormField,
  USStateSelectFormField,
  ICD10SearchFormField,
  RepeaterICD10FormField,
} from './DynamicFormFields';
import { DynamicFormFieldTypes } from '@common/types';
import { Divider } from '@mui/material';

interface IDynamicFormMapperProps {
  type: DynamicFormFieldTypes;
  name: string;
  label?: string;
  enum_options?: string[];
  disable_if?: string;
  disabled?: boolean;
  optional?: boolean;
  //For patient search
  patient_id?: string;
  onChangeCallback?: (nameList: string[]) => void;
  none_options?: string[];
  hide_if?: string;
  disable_past?: boolean;
  disable_future?: boolean;
}

export const ComponentMapper = ({
  type,
  ...props
}: IDynamicFormMapperProps) => {
  {
    switch (type) {
      case 'checkbox':
        return <CheckboxFormField {...props} />;
      case 'toggle':
        return <ToggleFormField {...props} />;
      case 'select':
        return (
          <SelectFormField
            options={props.enum_options?.map(o => ({
              value: o,
              label: o,
            }))}
            {...props}
          />
        );
      case 'multi_select':
        return (
          <MultiselectFormField
            options={props.enum_options?.map(o => ({
              value: o,
              label: o,
            }))}
            {...props}
          />
        );
      case 'checkbox_list':
        return (
          <CheckboxListFormField
            options={props.enum_options?.map(o => ({
              value: o,
              label: o,
            }))}
            {...props}
          />
        );
      case 'radio_vertical':
        return (
          <RadioButtonFormField
            options={props.enum_options?.map(o => ({
              value: o,
              label: o,
            }))}
            {...props}
            row={false}
          />
        );
      case 'radio':
        return (
          <RadioButtonFormField
            options={props.enum_options?.map(o => ({
              value: o,
              label: o,
            }))}
            {...props}
            row={true}
          />
        );

      case 'text':
        return <TextFormField {...props} />;
      case 'textbox':
        return <TextAreaFormField {...props} />;
      case 'repeater_textarea':
        return <RepeaterTextFormField multiline {...props} />;
      case 'repeater_textfield':
        return <RepeaterTextFormField {...props} />;
      case 'repeater_icd10':
        return <RepeaterICD10FormField {...props} />;
      case 'integer':
        return <NumberInputFormField {...props} />;
      case 'float':
        return <NumberInputFormField {...props} float />;
      case 'building_search':
        return <BuildingSearchFormField {...props} />;
      case 'respite_partner_search':
        return (
          <RespitePartnersSearchFormField
            {...props}
            patient_id={props.patient_id!}
          />
        );
      case 'provider_search':
        return <ProviderSearchFormField {...props} />;
      case 'icd10':
        return <ICD10SearchFormField {...props} />;
      case 'street':
        return <TextFormField {...props} />;
      case 'suite':
        return <TextFormField {...props} />;
      case 'city':
        return <TextFormField {...props} />;
      case 'state':
        return <USStateSelectFormField {...props} />;
      case 'zip':
        return <TextFormField {...props} />;
      case 'county':
        return <TextFormField {...props} />;
      case 'country':
        return <TextFormField {...props} />;
      case 'phone':
        return <TextFormField {...props} />;
      case 'email':
        return <TextFormField {...props} />;
      case 'date':
        return <DatepickerFormField {...props} />;
      case 'time':
        return <DatepickerFormField {...props} />;
      case 'mbi':
        return <TextFormField {...props} />;
      case 'divider':
        return <Divider sx={{ my: 2 }} />;
      case 'label':
        return <StaticLabelField {...props} />;
      case 'info_banner':
        return <BannerField {...props} variant={'info'} />;
      case 'warning_banner':
        return <BannerField {...props} variant={'warning'} />;
      case 'google_places_id':
        return <GooglePlacesAutocompleteDynamicFormField {...props} />;
      default:
        return <></>;
    }
  }
};
